import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createCaseTasklist = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createCaseTasklist($caseId: Int!, $name: String!, $position: Int!) {
          createCaseTasklist(caseId: $caseId, name: $name, position: $position ) { caseTasklist { id name position tasks { id name description } } error message lowLevelErrorMessage}
        }`),
      variables: { caseId: data.caseId, name: data.name, position: data.position }
    }
  )
  return response.data.createCaseTasklist
}

export const updateCaseTasklist = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation updateCaseTasklist($caseTasklistId: String!, $name: String!, $position: Int!) {
          updateCaseTasklist(caseTasklistId: $caseTasklistId, name: $name, position: $position )  { caseTasklist { id name position tasks { id name description } } error message lowLevelErrorMessage}
        }`),
      variables: { caseTasklistId: data.id, name: data.name, position: data.position }
    }
  )
  return response.data.updateCaseTasklist
}

export const deleteCaseTasklist = async (tasklistId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
      mutation deleteCaseTasklist($caseTasklistId: String!) {
        deleteCaseTasklist(caseTasklistId: $caseTasklistId) { error message lowLevelErrorMessage}
      }`),
      variables: { caseTasklistId: tasklistId }
    }
  )
  return response.data.deleteCaseTasklist
}
